import React from "react";
import Reviews from "../../components/Review";
import Concept from "../../components/ConceptSection";
import EffectsSection from "../../components/EffectsSection";
import FindUs from "../../components/FindUs";
import Hero from "../../components/Hero";
import FAQSection from "../../components/FAQSection";
import GiftCardBanner from "../../components/GiftCardBanner";
import SEO from "../../utils/SEO";

function Home() {
  return (
    <>
      <SEO
        title="Instant Iris"
        description="Instant Iris i Bergen - Spesialister på fotografering av iris. Eviggjør din iris på ønsket materiale og størrelse. Hvert øye er et mesterverk."
      />
      <main>
        <Hero />
        <Reviews />
        <Concept />
        <EffectsSection />
        <FindUs />
        <FAQSection />
        <GiftCardBanner />
      </main>
    </>
  );
}

export default Home;
